import { useEffect } from 'react'

const TITLE = 'Plan 07:00 — Entrenamiento de Roiner'

const META = [
  ['description', 'Plan de fuerza y registro de progreso.'],
  // Página personal: útil para mí, no para Google.
  ['robots', 'noindex, nofollow'],
  ['viewport', 'width=device-width, initial-scale=1, viewport-fit=cover'],
  // Pantalla de inicio del iPhone: barra de estado oscura y sin barra de Safari.
  ['theme-color', '#0D1321'],
  ['apple-mobile-web-app-capable', 'yes'],
  ['apple-mobile-web-app-status-bar-style', 'black-translucent'],
  ['apple-mobile-web-app-title', 'Plan 07:00'],
]

// A propósito solo en esta página: el resto del sitio usa Lato, no Oswald ni Inter.
const FONTS =
  'https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Inter:wght@400;500;600;700&display=swap'

/**
 * El equivalente al <Head> de Next: como esto es una SPA, el <head> es
 * compartido con el resto del sitio, así que hay que revertir cada cambio al
 * salir de la ruta o el tema oscuro se le queda pegado a las demás páginas.
 */
export function useEntrenamientoHead() {
  useEffect(() => {
    const previousTitle = document.title
    document.title = TITLE

    const undo = META.map(([name, content]) => {
      const existing = document.head.querySelector(`meta[name="${name}"]`)
      if (existing) {
        const previous = existing.getAttribute('content')
        existing.setAttribute('content', content)
        return () =>
          previous === null
            ? existing.removeAttribute('content')
            : existing.setAttribute('content', previous)
      }
      const tag = document.createElement('meta')
      tag.setAttribute('name', name)
      tag.setAttribute('content', content)
      document.head.appendChild(tag)
      return () => tag.remove()
    })

    // Los preconnect a Google Fonts ya viven en public/index.html.
    const fonts = document.createElement('link')
    fonts.rel = 'stylesheet'
    fonts.href = FONTS
    document.head.appendChild(fonts)

    return () => {
      document.title = previousTitle
      undo.forEach((revert) => revert())
      fonts.remove()
    }
  }, [])
}
